var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_501_26451",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4545 20.2619V16.9891C17.4545 15.8318 16.9948 14.7219 16.1765 13.9036C15.3581 13.0852 14.2482 12.6255 13.0909 12.6255H4.36364C3.20633 12.6255 2.09642 13.0852 1.27808 13.9036C0.459739 14.7219 0 15.8318 0 16.9891V20.2619"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9545 20.2619C15.9545 21.0903 16.6261 21.7619 17.4545 21.7619C18.283 21.7619 18.9545 21.0903 18.9545 20.2619H15.9545ZM13.0909 12.6255V11.1255V12.6255ZM4.36364 12.6255V11.1255V12.6255ZM0 16.9891H-1.5H0ZM-1.5 20.2619C-1.5 21.0903 -0.828427 21.7619 0 21.7619C0.828427 21.7619 1.5 21.0903 1.5 20.2619H-1.5ZM18.9545 20.2619V16.9891H15.9545V20.2619H18.9545ZM18.9545 16.9891C18.9545 15.434 18.3368 13.9426 17.2371 12.8429L15.1158 14.9642C15.6528 15.5013 15.9545 16.2296 15.9545 16.9891H18.9545ZM17.2371 12.8429C16.1375 11.7433 14.646 11.1255 13.0909 11.1255V14.1255C13.8504 14.1255 14.5788 14.4272 15.1158 14.9642L17.2371 12.8429ZM13.0909 11.1255H4.36364V14.1255H13.0909V11.1255ZM4.36364 11.1255C2.8085 11.1255 1.31706 11.7433 0.217418 12.8429L2.33874 14.9642C2.87578 14.4272 3.60415 14.1255 4.36364 14.1255V11.1255ZM0.217418 12.8429C-0.882226 13.9426 -1.5 15.434 -1.5 16.9891H1.5C1.5 16.2296 1.8017 15.5013 2.33874 14.9642L0.217418 12.8429ZM-1.5 16.9891V20.2619H1.5V16.9891H-1.5Z",
    fill: "#041967",
    mask: "url(#path-1-inside-1_501_26451)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3396 4.98913C12.3396 6.98488 10.7217 8.60276 8.72594 8.60276C6.73019 8.60276 5.1123 6.98488 5.1123 4.98913C5.1123 2.99337 6.73019 1.37549 8.72594 1.37549C10.7217 1.37549 12.3396 2.99337 12.3396 4.98913Z",
    stroke: "#041967",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePrimary);
export default __webpack_public_path__ + "static/media/profile_primary.05469e25d4f787ef61f9eae33702f069.svg";
export { ForwardRef as ReactComponent };